export const SecurityDepositEnum = {
  Paid: 'paid',
  Pending: 'pending',
  Refunded: 'refunded',
};
